import { memo, useRef } from "react";
import Lottie, { LottieRefCurrentProps } from "lottie-react";
import invoiceAnimation from "ui/theme/animations/invoice.json";
import Logo from "ui/modules/public/components/Logo/Logo";

const ListingSummaryCard: React.FC = () => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleLoopComplete = () => {
    if (!lottieRef.current) return;
    lottieRef.current.stop();
    const totalFrames = lottieRef.current.getDuration(true) ?? 0;
    if (totalFrames > 0) {
      lottieRef.current.goToAndStop(totalFrames - 1, true);
    }
  };

  return (
    <div className="bg-blue-700 h-full w-full relative flex flex-col items-center justify-center overflow-hidden">
      <Logo variant="light" animated className="absolute top-8 left-8" />
      <Lottie
        lottieRef={lottieRef}
        animationData={invoiceAnimation}
        autoplay={true}
        loop={true}
        onLoopComplete={handleLoopComplete}
        className="w-[500px] h-auto"
      />
      <div className="text-center max-w-md px-4">
        <h1 className="text-4xl leading-[46px] font-bold mb-3 text-white">
          Objavite oglas u tren!
        </h1>
        <p className="text-lg opacity-80 text-blue-50">
          Odaberite oglasnike na koje želite objaviti vozilo, dodajte slike i osnovne podatke. Sustav će automatski sinkronizirati oglas na svim odabranim platformama.
        </p>
      </div>
    </div>
  );
};

export default memo(ListingSummaryCard);
